import type { IGroupDetail, IConfigurationInfo, IUserDetail, EUserSelection, IGraphPickerItem } from "../../../interfaces";
import { AssignUsers } from "../../AssignUsers/AssignUsers";

export interface IUsersTabProps {
    configurationInfo?: IConfigurationInfo;
    isLoading?: boolean;
    userDetails: IUserDetail[];
    groupDetails: IGroupDetail[];
    selectedPeople: IGraphPickerItem[];
    usersToBeAdded: IUserDetail[];
    groupsToBeAdded: IGroupDetail[];
    userSelection: EUserSelection;
    usersToBeRemoved: IUserDetail[];
    groupsToBeRemoved: IGroupDetail[];
    onUserSelectionChange(value: EUserSelection): void;
    onPeopleSelect(people: IGraphPickerItem[]): void;
    onUsersRemove(userIds: string[]): void;
    onGroupsRemove(groupIds: string[]): void;
    onUserToBeRemovedRemove(userId: string): void;
    onGroupToBeRemovedRemove(groupId: string): void
}

export const UsersTab = (props: IUsersTabProps) => {
    return (
        <>
            <h3>Assign users</h3>
            <AssignUsers {...props} />
        </>
    );
};
